'use client'

import { useState, useEffect } from 'react'

export function useMediaQuery(query: string): boolean {
  // SSR-safe: start with a stable default so server and first client render match,
  // then resolve the real value in the effect (runs before paint).
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)

    mql.addEventListener('change', handler)
    setMatches(mql.matches)

    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}

/** True when user has a hover-capable pointer (desktop) */
export function useIsDesktop(): boolean {
  return useMediaQuery('(hover: hover) and (pointer: fine)')
}

/** True when user prefers reduced motion */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)')
}
